/**
 * How long a film an account marked "already seen" stays out of their swipe
 * deck. `null` means forever — the default, since a film somebody says they
 * have already seen is assumed settled for good unless they say otherwise.
 */
export const SEEN_EXCLUSION_OPTIONS = [7, 30, 90, 180, 365];
export function isValidSeenExclusionDays(value) {
    return (value === null ||
        (typeof value === 'number' && SEEN_EXCLUSION_OPTIONS.includes(value)));
}
/** Whether a seen mark from `seenAt` has aged out under `exclusionDays` (`null` = never). */
export function seenMarkExpired(seenAt, exclusionDays, now = Date.now()) {
    if (exclusionDays === null)
        return false;
    return now - seenAt > exclusionDays * 24 * 60 * 60 * 1000;
}
